module.exports = {"markup":"<span class=\"inline-arrow inline-icon\"><svg width=\"24\" height=\"10\" viewBox=\"0 0 24 10\"><path d=\"M0 .7l10.5 8.4 1.1.9 1.1-.9 10.5-8.4-.5-.7-11.1 6.3-11-6.3-.6.7z\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./dev/webpack-loaders/svg-loader!./static/src/inline-svgs/icon/arrow.svg
// module id = 253
// module chunks = 0 1 18